import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import userService from '../../services/userService';
import { IconUserPlus, IconLock, IconMail, IconUser, IconBuildingSkyscraper, IconBriefcase, IconPhone, IconWorld } from '@tabler/icons-react';

export const AddMember = () => {
    const { t, i18n } = useTranslation();

    const handleSubmit = async (e) => {

        e.preventDefault();
        let regobj = { 
            UserId, FirmaAdi, Bolum, AdiSoyadi, Eposta, Sifre, Telefon, WebSitesi, 
            MailDogrulama, ActivationKey, Rol, Language,
            RizaOnay: kvkkAccepted ? 1 : 0,
            RizaOnayDate: kvkkAccepted ? new Date().toISOString() : null
        }

        if (IsValidate()) {
            try {
                const res = await userService.addMember(regobj);
                console.log("addMember response:", res, typeof res);
                if (res === "OK") {
                    navigate('/login', {
                        state: {
                            showActivationNotice: true,
                            registeredEmail: Eposta
                        }
                    });
                } else {
                    toast(res)
                }
            } catch (err) {
                toast.error(t('mesajKayitYapilamiyor') + (err.message || ""))
            }
        }
    }

    const [UserId, idChange] = useState(0);
    const [Eposta, EpostaChange] = useState("");
    const [Sifre, sifreChange] = useState("");
    const [AdiSoyadi, adSoyadChange] = useState("");
    const [FirmaAdi, FirmaAdiChange] = useState("");
    const [Bolum, bolumChange] = useState("");
    const [WebSitesi, webSitesiChange] = useState("");
    const [Telefon, telefonChange] = useState("");
    const [MailDogrulama, mailDogrulamaChange] = useState(0)
    const [ActivationKey, setaKey] = useState("")
    const [Rol, setRol] = useState("2")
    const [Language, setLanguage] = useState(i18n.language)

    const [emailError, setEmailError] = useState(""); // E-posta hata state'i

    // KVKK States
    const [kvkkAccepted, setKvkkAccepted] = useState(false);
    const [showKvkkModal, setShowKvkkModal] = useState(false);
    const [kvkkContent, setKvkkContent] = useState("");

    useEffect(() => {
        // KVKK metnini yükle
        fetch('/kvkk.html')
            .then(response => response.text())
            .then(data => setKvkkContent(data))
            .catch(err => console.error("KVKK metni yüklenemedi", err));
    }, []);

    const handleKvkkOpen = () => setShowKvkkModal(true);
    const handleKvkkClose = () => setShowKvkkModal(false);
    const handleKvkkAccept = () => {
        setKvkkAccepted(true);
        setShowKvkkModal(false);
    };

    const handleEmailBlur = async () => {
        if (!Eposta) {
            setEmailError("");
            return;
        }

        // Regex kontrolü
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(Eposta)) {
            setEmailError(t('mesajEPostaUyari'));
            return;
        }

        try {
            // Eğer editMode ise ve e-posta değişmediyse kontrol etme (kendi e-postası)
            // Ancak AddMember.js hem yeni kayıt hem edit (profilim) için kullanılıyor olabilir.
            // Edit modunda mevcut e-posta ile aynıysa servise sormaya gerek yok.
            // Mevcut e-posta bilgisini bir yerde tutmamız lazım (initialEmail).

            // Yeni kayıt için kontrol:
            if (!editMode) {
                const response = await userService.checkEmail(Eposta);

                // API { exists: true, message: "..." } dönüyor
                if (response && response.exists === true) {
                    setEmailError(t('mesajEpostaKullanimda'));
                } else {
                    setEmailError("");
                }
            }
        } catch (error) {
            console.error("Email check error:", error);
        }
    };

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, ""); // Sadece rakamları al
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        if (phoneNumberLength < 9) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 8)} ${phoneNumber.slice(8, 10)}`;
    };

    const handlePhoneChange = (e) => {
        const formattedValue = formatPhoneNumber(e.target.value);
        if (formattedValue.length <= 15) { // (xxx) xxx xx xx formatı max 15 karakter
            telefonChange(formattedValue);
        }
    };

    const editMode = sessionStorage.getItem("userId") ? true : false;

    const navigate = useNavigate();
    const IsValidate = () => {
        let isProceed = true;
        let errorMessage = t('mesajUyelikBosAlanlar');

        if (emailError) {
            isProceed = false;
            errorMessage = emailError;
            // toast ile göstermeye gerek yok, input altında zaten yazıyor.
            // Ama genel hata mesajı yapısını bozmamak için devam edelim.
        }

        if (Eposta === null || Eposta === '') {
            isProceed = false;
            errorMessage += t('formUyelikEposta') + ' ';
        }

        if (Sifre === null || Sifre === '') {
            isProceed = false;
            errorMessage += t('formUyelikSifre') + ' ';
        }

        if (AdiSoyadi === null || AdiSoyadi === '') {
            isProceed = false;
            errorMessage += t('formUyelikAdSoyad') + ' ';
        }

        if (Sifre.length > 12) {
            isProceed = false;
            errorMessage += t('mesajSifreUzunluguUyari');
        }

        if (Sifre.length < 6) {
            isProceed = false;
            errorMessage += t('mesajSifreUzunluguUyari');
        }
        if (FirmaAdi.length < 3) {
            isProceed = false;
            errorMessage += t('mesajFirmaAdiUyari');
        }

        if (Telefon.length < 15) { // Maskeli halinin uzunluğu kontrolü
            isProceed = false;
        }

        if (!kvkkAccepted && !editMode) {
            isProceed = false;
            errorMessage = t('kvkkHata');
        }

        if (!isProceed) {
            toast.warning(errorMessage)
        } else {
            // Gelişmiş E-posta Regex
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(Eposta)) {
                isProceed = false;
                toast.warning(t('mesajEPostaUyari'))
            }
        }
        return isProceed;
    }

    const changeLang = async (lang) => {
        await i18n.changeLanguage(lang);
        localStorage.setItem('siteLang', lang);
    }

    const sectionLabel = {
        fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
        letterSpacing: '1px', color: '#94a3b8',
        marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px',
    };

    const fieldLabel = {
        fontSize: '12px', fontWeight: 600, color: '#475569',
        marginBottom: '6px', display: 'block',
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #1e2a38 0%, #2563a8 100%)',
            padding: '32px 24px',
        }}>
            <div style={{ maxWidth: '680px', margin: '0 auto' }}>

                {/* ── Üst Bar: Logo + Başlık + Dil ── */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div style={{
                            background: '#fff', borderRadius: '12px', padding: '10px 14px',
                            display: 'inline-flex', boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        }}>
                            <img src="kama-3d-logo.png" alt="Kama 3D" style={{ width: 90 }} />
                        </div>
                        <div>
                            <h5 style={{ color: '#fff', fontWeight: 700, margin: 0 }}>
                                {t('formUyelikBaslikYeni')}
                            </h5>
                            <small style={{ color: 'rgba(255,255,255,0.45)' }}>
                                {i18n.language.startsWith('tr') ? 'Kama 3D Doküman Merkezi' : 'Kama 3D Document Center'}
                            </small>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <img src="flag-tr.png" alt="TR" onClick={() => changeLang('tr')}
                            style={{ width: 24, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('tr') ? 1 : 0.3, transition: 'opacity 0.2s' }} />
                        <img src="flag-en.png" alt="EN" onClick={() => changeLang('en')}
                            style={{ width: 24, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('en') ? 1 : 0.3, transition: 'opacity 0.2s' }} />
                    </div>
                </div>

                <form onSubmit={handleSubmit} autoComplete="off">

                    {/* ── Hesap Bilgileri ── */}
                    <div className="card border-0 shadow-sm rounded-4 mb-3">
                        <div className="card-body p-4">
                            <div style={sectionLabel}>
                                <IconLock size={14} />
                                {t('formUyelikEposta')} & {t('formUyelikSifre')}
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikEposta')} *</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconMail size={16} color="#94a3b8" /></span>
                                        <input
                                            type="text"
                                            className={`form-control border-start-0 ps-1 ${emailError ? 'is-invalid' : ''}`}
                                            value={Eposta}
                                            onChange={(e) => { EpostaChange(e.target.value); setEmailError(""); }}
                                            onBlur={handleEmailBlur}
                                            placeholder="ornek@kama.com.tr"
                                            autoComplete="new-email"
                                        />
                                        {emailError && <div className="invalid-feedback">{emailError}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikSifre')} *</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconLock size={16} color="#94a3b8" /></span>
                                        <input
                                            type="password"
                                            className="form-control border-start-0 ps-1"
                                            value={Sifre}
                                            onChange={(e) => sifreChange(e.target.value)}
                                            placeholder="••••••"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Kişisel Bilgiler ── */}
                    <div className="card border-0 shadow-sm rounded-4 mb-3">
                        <div className="card-body p-4">
                            <div style={sectionLabel}>
                                <IconUser size={14} />
                                {t('formUyelikAdSoyad')} & {t('formUyelikFirmaAdi')}
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikAdSoyad')} *</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconUser size={16} color="#94a3b8" /></span>
                                        <input type="text" className="form-control border-start-0 ps-1" value={AdiSoyadi} onChange={(e) => adSoyadChange(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikFirmaAdi')} *</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconBuildingSkyscraper size={16} color="#94a3b8" /></span>
                                        <input type="text" className="form-control border-start-0 ps-1" value={FirmaAdi} onChange={(e) => FirmaAdiChange(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label style={fieldLabel}>{t('formUyelikBolum')}</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconBriefcase size={16} color="#94a3b8" /></span>
                                        <input type="text" className="form-control border-start-0 ps-1" value={Bolum} onChange={(e) => bolumChange(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── İletişim ── */}
                    <div className="card border-0 shadow-sm rounded-4 mb-3">
                        <div className="card-body p-4">
                            <div style={sectionLabel}>
                                <IconPhone size={14} />
                                {t('formUyelikTelefon')} & {t('formUyelikWebSitesi')}
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikTelefon')} *</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconPhone size={16} color="#94a3b8" /></span>
                                        <input type="text" className="form-control border-start-0 ps-1" value={Telefon} onChange={handlePhoneChange} placeholder="(5XX) XXX XX XX" maxLength="15" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label style={fieldLabel}>{t('formUyelikWebSitesi')}</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0"><IconWorld size={16} color="#94a3b8" /></span>
                                        <input type="text" className="form-control border-start-0 ps-1" value={WebSitesi} onChange={(e) => webSitesiChange(e.target.value)} placeholder="www.firma.com.tr" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── KVKK ── */}
                    {!editMode && (
                        <div className="card border-0 shadow-sm rounded-4 mb-3">
                            <div className="card-body p-4">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="kvkkCheck"
                                        checked={kvkkAccepted} onChange={(e) => setKvkkAccepted(e.target.checked)} />
                                    <label className="form-check-label" htmlFor="kvkkCheck" style={{ fontSize: '13px', color: '#475569' }}>
                                        <span
                                            style={{ color: '#2563a8', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
                                            onClick={handleKvkkOpen}
                                        >
                                            {i18n.language.startsWith('tr') ? 'Kişisel Verilerin Korunması' : 'Personal Data Protection'}
                                        </span>
                                        {' '} {t('kvkkOnayMetni')}
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ── Butonlar ── */}
                    <div className="d-flex justify-content-end gap-2 mb-4">
                        <Link to={editMode ? '/' : '/login'} className="btn btn-outline-light px-4">
                            {t('butonVazgec')}
                        </Link>
                        <button type="submit" className="btn btn-light px-4 fw-bold">
                            {editMode ? t('butonGuncelle') : t('butonKayitOl')}
                        </button>
                    </div>
                </form>
            </div>

            {/* ── KVKK Modal ── */}
            <Modal show={showKvkkModal} onHide={handleKvkkClose} size="lg" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Kişisel Verilerin Korunması</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: kvkkContent }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleKvkkClose}>Kapat</Button>
                    <Button variant="primary" onClick={handleKvkkAccept}>Okudum, Anladım</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );

}

